import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import Utils from '../../library/Utils.js';
import ABCyaPhaser, { Audio } from '@abcya/abcya_phaser';

export default class Vial extends AContainer {
  constructor(scene, x, y, ind, color, controller) {
    super(scene);

    this.scene = scene;
    this.color = color;
    this.startX = x;
    this.startY = this.scene.mid.y - 100;
    this.origY = y;
    this.ind = ind;
    this.pCont = controller;

    this.topVials = [];
    this.bottomVials = [];
    this.vials = [];

    this.counter = 0;
    this.hasCounter = false;
    this.isDragging = false;
    this.vialInd = null;
    this.isCorrect = false;
    this.directionalBug = null;
    this.largest = null;
    this.smallest = null;

    this.createVial();
    //this.createCounter();
  }

  createVial() {
    let bottomVial = this.scene.addContainer(this.startX, this.origY).setDepth(1);
    let topVial = this.scene.addContainer(this.startX, this.origY).setDepth(3);

    let bottom = this.scene.addImage(0, 0, "Jar", this.scene.defaultAtlas, bottomVial);
    this.top = this.scene.addButton(0, 0, "Jar", {}, () => {
      if (gameData.level === 1 || gameData.level === 3 || gameData.level === 5 || gameData.level === 7) this.createCounter();
      else if (gameData.level === 10 || gameData.level === 11) this.checkAmount();
      else if (gameData.level === 13) this.alignBugs("left");
    }, topVial);
    this.band = this.scene.addImage(0, -120, "Jar_" + this.color.name, this.scene.defaultAtlas, topVial);

    this.top.setAlpha(.375);
    this.top.setEnabled(false);

    this.name = this.color.name;
    this.startColor = this.color.color;
    this.color = this.color.color;
    this.bugCount = 0;
    this.isCustom = false;

    this.bottomVials.push(bottomVial);
    this.topVials.push(topVial);
    this.vials.push([topVial, bottomVial]);

    this.maxWidth = this.top.width;
    this.maxHeight = this.top.height;
    this.topVials[0].setSize(this.maxWidth, this.maxHeight);

    this.topVials[0].on('dragstart', (pointer) => {
      this.isDragging = true;
      this.topVials[0].setDepth(100);
      this.bottomVials[0].setDepth(98);
      gameData.vialBugs[this.ind].forEach((bug) => { bug.setDepth(99); });
    });

    this.topVials[0].on('drag', (pointer, dragX, dragY) => {
      //console.log("dragging");
      this.topVials[0].x = dragX;
      this.topVials[0].y = dragY;
      this.bottomVials[0].x = this.topVials[0].x;
      this.bottomVials[0].y = this.topVials[0].y;
      gameData.vialBugs[this.ind].forEach((bug) => {
        bug.x = this.bottomVials[0].x + bug.jarPos.x - this.startX;
        bug.y = this.bottomVials[0].y + bug.jarPos.y - this.startY;
      });
    });

    this.topVials[0].on('dragend', (pointer) => {
      let closestDist = Number.MAX_VALUE;
      let closestOutline = null;

      this.scene.outlines.forEach((outline) => {
        let questionLoc = Utils.StagePos(outline);
        let dist = Phaser.Math.Distance.Between(pointer.x, pointer.y, questionLoc.x, questionLoc.y);

        if (dist <= 100 && !outline.isFilled && dist < closestDist) {
          closestDist = dist;
          closestOutline = outline;
        }
      });

      if (closestOutline) {
        this.disableDrag();

        this.topVials[0].setDepth(3);
        this.bottomVials[0].setDepth(1);

        this.scene.setOutlinePos(closestOutline, this);

        this.scene.addTween(this.topVials[0], 500, { x: closestOutline.x, y: closestOutline.y }, Phaser.Math.Easing.Back.Out);
        this.scene.addTween(this.bottomVials[0], 500, { x: closestOutline.x, y: closestOutline.y }, Phaser.Math.Easing.Back.Out);
        gameData.vialBugs[this.ind].forEach((bug) => {
          bug.setDepth(2);
          this.scene.addTween(bug, 500, { x: bug.outlinePos.x, y: bug.outlinePos.y }, Phaser.Math.Easing.Back.Out);
        });

        // console.log(closestOutline.correctNum, this.bugCount);
        if (closestOutline.correctNum === this.bugCount) {
          gameData.vialBugs[this.ind].forEach((bugs) => { bugs.character.play("Cheer", false); });
          this.scene.playSound("correct_answer", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);

          gameData.totalOutlines++;
          this.vialInd = closestOutline.ind;
          this.isCorrect = true;
          closestOutline.isFilled = true;

          if (gameData.totalOutlines === 4) this.scene.addDelay(4750, () => { this.scene.goToQuestions(); });
        } else {
          this.scene.playIncorrectSound();

          gameData.vialBugs[this.ind].forEach((bugs) => { bugs.character.play("Sad", false); });
          this.scene.addDelay(2000, () => { this.returnToStart(); })
        }
      } else {
        this.returnToStart();
      }
    });
  }

  returnToStart() {
    this.vialInd = null;

    this.topVials[0].setDepth(3);
    this.bottomVials[0].setDepth(1);
    this.scene.addTween(this.topVials[0], 500, { x: this.startX, y: this.startY }, Phaser.Math.Easing.Back.Out);
    this.scene.addTween(this.bottomVials[0], 500, { x: this.startX, y: this.startY }, Phaser.Math.Easing.Back.Out,
      () => { this.enableDrag(); });
    gameData.vialBugs[this.ind].forEach((bug) => {
      bug.setDepth(2);
      this.scene.addTween(bug, 500, { x: bug.jarPos.x, y: bug.jarPos.y }, Phaser.Math.Easing.Back.Out);
    });
  }

  toggleVial(TorF) {
    //console.log("toggling", TorF);
    if (TorF === true) {
      if (!this.hasCounter) this.top.setEnabled(TorF);
    } else {
      this.top.setEnabled(TorF);
    }
  }

  enableDrag() {
    //console.log("toggling", TorF);
    this.topVials[0].setInteractive();
    this.scene.input.setDraggable(this.topVials[0]);
  }

  disableDrag() {
    this.disableInteractive();
    this.scene.input.setDraggable(this.topVials[0], false);
  }

  setDirectionalBug(direction) {
    let tempArr = [...gameData.vialBugs[this.ind]];
    let tempArr2 = [...gameData.upDownBugs];
    if (direction === "left" || direction === "right") tempArr.sort((a, b) => (a.x > b.x) ? 1 : -1);
    else if (direction === "up" || direction === "down") tempArr2.sort((a, b) => (a.y > b.y) ? 1 : -1);

    if (direction === "left") this.directionalBug = tempArr[0];
    else if (direction === "up") this.directionalBug = tempArr2[0];
    else if (direction === "right") this.directionalBug = tempArr[tempArr.length - 1];
    else if (direction === "down") this.directionalBug = tempArr2[tempArr2.length - 1];

    if (direction === "largest") {
      let highLow = Phaser.Math.Between(1, 2);
      //let base = Math.floor(gameData.vialBugs[this.ind].length/2);
      if (highLow === 1) {
        if (tempArr.length === 2) {
          this.largest = tempArr[0];
          this.smallest = tempArr[1];
        }
        else if (tempArr.length === 3) {
          this.largest = tempArr[0];
          this.smallest = tempArr[Phaser.Math.Between(1, 2)];
        }
        else if (tempArr.length === 4) {
          this.largest = tempArr[Phaser.Math.Between(0, 1)];
          this.smallest = tempArr[Phaser.Math.Between(2, 3)];
        }
        else if (tempArr.length === 5) {
          this.largest = tempArr[Phaser.Math.Between(0, 2)];
          this.smallest = tempArr[Phaser.Math.Between(3, 4)];
        }
        else if (tempArr.length === 6) {
          this.largest = tempArr[Phaser.Math.Between(0, 2)];
          this.smallest = tempArr[Phaser.Math.Between(3, 5)];
        }
        else if (tempArr.length === 7) {
          this.largest = tempArr[Phaser.Math.Between(0, 3)];
          this.smallest = tempArr[Phaser.Math.Between(4, 6)];
        }
        else if (tempArr.length === 8) {
          this.largest = tempArr[Phaser.Math.Between(0, 3)];
          this.smallest = tempArr[Phaser.Math.Between(4, 7)];
        }
        else if (tempArr.length === 9) {
          this.largest = tempArr[Phaser.Math.Between(0, 4)];
          this.smallest = tempArr[Phaser.Math.Between(5, 8)];
        }
      } else {
        if (tempArr.length === 2) {
          this.smallest = tempArr[0];
          this.largest = tempArr[1];
        }
        else if (tempArr.length === 3) {
          this.smallest = tempArr[0];
          this.largest = tempArr[Phaser.Math.Between(1, 2)];
        }
        else if (tempArr.length === 4) {
          this.smallest = tempArr[Phaser.Math.Between(0, 1)];
          this.largest = tempArr[Phaser.Math.Between(2, 3)];
        }
        else if (tempArr.length === 5) {
          this.smallest = tempArr[Phaser.Math.Between(0, 2)];
          this.largest = tempArr[Phaser.Math.Between(3, 4)];
        }
        else if (tempArr.length === 6) {
          this.smallest = tempArr[Phaser.Math.Between(0, 2)];
          this.largest = tempArr[Phaser.Math.Between(3, 5)];
        }
        else if (tempArr.length === 7) {
          this.smallest = tempArr[Phaser.Math.Between(0, 3)];
          this.largest = tempArr[Phaser.Math.Between(4, 6)];
        }
        else if (tempArr.length === 8) {
          this.smallest = tempArr[Phaser.Math.Between(0, 3)];
          this.largest = tempArr[Phaser.Math.Between(4, 7)];
        }
        else if (tempArr.length === 9) {
          this.smallest = tempArr[Phaser.Math.Between(0, 4)];
          this.largest = tempArr[Phaser.Math.Between(5, 8)];
        }
      }

      this.largest.largest = true;
      this.smallest.smallest = true;
    }
  }

  disableBugs() {
    gameData.vialBugs[this.ind].forEach((bug) => { bug.disabled(); });
  }

  enableBugs() {
    gameData.vialBugs[this.ind].forEach((bug) => { bug.enabled(true); });
  }

  alignBugs(direction) {
    if (direction === "left") {
      this.scene.playSound("which_fb_left", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "which_fb_left";

      this.scene.disableBugs();
      this.pCont.toggleVials(false);
      this.pCont.activeJar = this.ind;

      let fuzzWidth = 65;
      let maxW = fuzzWidth + (fuzzWidth * gameData.vialBugs[this.ind].length);
      let startX = this.scene.mid.x - maxW / 2 + fuzzWidth;

      this.scene.playSound("fb_group_move");

      //console.log(gameData.vialBugs[this.ind].length, maxW, newX);
      for (let i = 0; i < gameData.vialBugs[this.ind].length; i++) {
        this.scene.addDelay(100 * i, () => { gameData.vialBugs[this.ind][i].character.play("JumpFull", false); });
        this.scene.addTween(gameData.vialBugs[this.ind][i], 1000, { x: startX + (fuzzWidth * i), y: this.scene.shelf.y - 20, delay: 100 * i }, Phaser.Math.Easing.Quadratic.InOut,
          () => {
            if (i >= gameData.vialBugs[this.ind].length - 1) {
              console.log("last");
              gameData.level++;
              this.scene.navBar.updateLevel();

              gameData.transition = false;

              this.setDirectionalBug("left");
            }
          });
      }
    }
    else if (direction === "right") {
      gameData.level++;
      this.scene.navBar.updateLevel();

      this.scene.playSound("which_fb_right", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "which_fb_right";

      gameData.transition = false;

      this.setDirectionalBug("right");
      this.enableBugs();
    }
    else if (direction === "up") {
      gameData.level++;
      this.scene.navBar.updateLevel();

      this.scene.playSound("fb_group_move");
      this.scene.playSound("tap_fb_top", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "tap_fb_top";

      for (let i = 0; i < gameData.vialBugs[this.ind].length; i++) {
        gameData.vialBugs[this.ind][i].disabled();

        if (i >= 5) {
          gameData.vialBugs[this.ind][i].isOff = true;
          this.scene.addDelay(100 * i, () => { gameData.vialBugs[this.ind][i].character.play("WalkingRight", true); });
          this.scene.addTween(gameData.vialBugs[this.ind][i], 2000, { x: this.scene.mid.x * 2 + 50, delay: 100 * i });
        } else {
          this.scene.addDelay(100 * i, () => { gameData.vialBugs[this.ind][i].character.play("JumpFull", false); });
          this.scene.addTween(gameData.vialBugs[this.ind][i], 1000, { x: this.scene.mid.x, y: this.scene.shelf.y - 20 - (52 * i), delay: 100 * i }, Phaser.Math.Easing.Quadratic.InOut);

          gameData.upDownBugs.push(gameData.vialBugs[this.ind][i]);
        }
      }
      this.scene.addDelay(1500, () => {
        // console.log("last");
        this.setDirectionalBug("up");

        gameData.transition = false;
      });
    }
    else if (direction === "down") {
      gameData.level++;
      this.scene.navBar.updateLevel();

      this.scene.playSound("tap_fb_bottom", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "tap_fb_bottom";

      gameData.transition = false;

      this.setDirectionalBug("down");
      this.enableBugs();
    }
    else if (direction === "largest") {
      gameData.level++;
      this.scene.navBar.updateLevel();

      this.setDirectionalBug("largest");
      this.scene.playSound("tap_largest_fb", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "tap_largest_fb";

      this.scene.addTween(this.largest.character.spine, 1500, { scaleX: .25, scaleY: .25 }, Phaser.Math.Easing.Quadratic.Out);
      this.scene.addTween(this.smallest.character.spine, 1500, { scaleX: .09, scaleY: .09 }, Phaser.Math.Easing.Quadratic.Out);

      let fuzzWidth = 65;
      let maxW = fuzzWidth + (fuzzWidth * gameData.vialBugs[this.ind].length);
      let startX = this.scene.mid.x - maxW / 2 + fuzzWidth;

      for (let i = 0; i < gameData.vialBugs[this.ind].length; i++) {
        if (i >= 5) {
          gameData.vialBugs[this.ind][i].isOff = false;
          gameData.vialBugs[this.ind][i].character.play("WalkingLeft", true);
          this.scene.addTween(gameData.vialBugs[this.ind][i], 1000, { x: startX + (fuzzWidth * i), y: this.scene.shelf.y - 20, delay: 100 * i }, Phaser.Math.Easing.Quadratic.InOut,
            () => {
              if (i >= gameData.vialBugs[this.ind].length - 1) {
                // console.log("last", gameData.level);
                gameData.transition = false;

                this.enableBugs();
                this.largest.setLargestSize();
              }
            });
        } else {
          this.scene.addDelay(100 * i, () => { gameData.vialBugs[this.ind][i].character.play("JumpFull", false); });
          this.scene.addTween(gameData.vialBugs[this.ind][i], 1000, { x: startX + (fuzzWidth * i), y: this.scene.shelf.y - 20, delay: 100 * i }, Phaser.Math.Easing.Quadratic.InOut,
            () => {
              this.largest.setLargestSize();
            });
        }
      }
    }
    else if (direction === "smallest") {
      gameData.level++;
      this.scene.navBar.updateLevel();
      this.scene.playSound("tap_smallest_fb", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "tap_smallest_fb";
      gameData.transition = false;
      this.enableBugs();
    }
  }

  checkAmount() {
    //console.log(this.counter);
    if (gameData.level === 10) {
      if (this.counter === this.pCont.getMinMax("min")) {
        // console.log("FOUND LEAST");
        this.scene.playSound("correct_answer", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
        this.pCont.toggleVials(false);
        gameData.vialBugs[this.ind].forEach((bug) => { bug.character.play("Cheer", true) });

        this.scene.addDelay(3000, () => { this.scene.goToQuestions(); });
      } else {
        //console.log("NOT LEAST");
        this.scene.playIncorrectSound();
        gameData.vialBugs[this.ind].forEach((bug) => { bug.character.play("Sad", false) });
      }
    }
    else if (gameData.level === 11) {
      if (this.counter === this.pCont.getMinMax("max")) {
        // console.log("FOUND MAX");
        this.scene.playSound("correct_answer", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
        this.pCont.toggleVials(false);
        gameData.vialBugs[this.ind].forEach((bug) => { bug.character.play("Cheer", true) });

        this.scene.addDelay(3000, () => { this.scene.goToQuestions(); });
      } else {
        //console.log("NOT MAX");
        this.scene.playIncorrectSound();
        gameData.vialBugs[this.ind].forEach((bug) => { bug.character.play("Sad", false) });
      }
    }
  }

  createCounter() {
    this.hasCounter = true;
    gameData.selectedJar = this;

    if (this.scene.inst) {
      //console.log(this.scene.inst); 
      this.scene.inst.stop();
    }
    this.scene.playSound("tap_on_fb_to_count", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
    gameData.levelSound = "tap_on_a_jar";

    this.bg = this.scene.addImage(0, -120, "Number_Badge", this.scene.defaultAtlas, this.topVials[0]);
    this.txt = this.scene.addText(0, -124, 40, "0xf2eddf", gameData.fonts.numPad, this.counter, this.topVials[0], true);

    // console.log(this.isCustom, gameData.fuzzColor, this.startColor);
    if (this.isCustom) {
      this.bg.tint = "0x" + gameData.fuzzColor;
      if (gameData.fuzzColor === "f2eddf" || gameData.fuzzColor === "f7db0f") this.txt.tint = 0x383334;
    } else {
      this.bg.tint = "0x" + this.startColor;
      if (this.startColor === "f2eddf" || this.startColor === "f7db0f") this.txt.tint = 0x383334;
    }

    this.pCont.toggleVials(false);
    this.scene.activateBugs(this);

    gameData.level++;
    this.scene.navBar.updateLevel();
  }

  removeCounter() {
    this.scene.addTween(this.bg, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In,
      () => { this.bg.destroy(); });
    this.scene.addTween(this.txt, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In,
      () => { this.txt.destroy(); });

    this.hasCounter = false;
    this.counter = 0;
  }

  updateCounter() {
    this.counter++;
    if (this.txt) this.txt.text = this.counter;

    const numberAudio = this.scene.playSound(String(this.counter), 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);

    if(this.counter >= gameData.vialBugs[this.ind].length) {
      numberAudio.once(Phaser.Sound.Events.COMPLETE, ()=> {
        this.scene.goToQuestions();
      });
    }
  }

  setCustom() {
    //console.log(gameData.fuzzStencilName, gameData.fuzzColorName, gameData.fuzzStencilColor);
    this.isCustom = true;
    gameData.customReplacementColor = this.name;

    this.band.destroy();
    this.band = this.scene.addImage(0, -120, "Jar_" + gameData.fuzzColorName, this.scene.defaultAtlas, this.topVials[0]);

    let pattern = this.scene.addImage(0, -120, "Jar_" + gameData.fuzzStencilName, this.scene.defaultAtlas, this.topVials[0]);
    let color = "0x" + gameData.fuzzStencilColor.toString();
    pattern.setTint(color);
  }

  cleanUp() {
    //console.log("cleaning UP");
    this.bottomVials.forEach((vial) => { vial.destroy(); });
    this.topVials.forEach((vial) => { vial.destroy(); });

    this.bottomVials = [];
    this.topVials = [];
    this.vials = [];
  }
}